module.exports = __webpack_public_path__ + "img/ic_questions_technic.895894f5.svg";